import React, { } from "react";
import emptyMessage from "src/assets/icons/empty-message.png";

const EmptyMessage = (props) => {
    const {type} = props

    return (
        <>
        {type!=="authentication" &&
            <div className="text-center mb-5 mt-4">
                <div className="">
                <img src={emptyMessage} className="c-sidebar-brand-full mobile-logo-width img-fluid" />{" "}
                </div>
                <h5 className="bold-label">No Data Available</h5>
                <p className="status-font min-font-size">There is no data to show you right now.</p>
            </div>}
            
        {type==="authentication" &&
            <div className="text-center mb-5 mt-4">
                <div className="">
                {/* <img src={emptyMessage} className="c-sidebar-brand-full mobile-logo-width img-fluid" />{" "} */}
                </div>
                <h5 className="bold-label">No Data Available</h5>
                <p className="status-font min-font-size">There is no data to show you right now.</p>
            </div>}
        </>
    );
};
export default EmptyMessage;
